import { createAction } from "@reduxjs/toolkit";

export const setActiveAccount = createAction("account/setActive");
export const clearActiveAccount = createAction("account/clear");

